document.addEventListener('DOMContentLoaded', function () {
  const searchWrapper = document.querySelector('.custom-header__search-wrapper');
  const searchOverlay = document.querySelector('.search-overlay');
  const searchButtons = document.querySelectorAll('.search-button');
  const closeButton = document.querySelector('.search__icon-close');

  if (!searchWrapper || !searchOverlay || !searchButtons.length || !closeButton) return;

  function openSearch() {
    searchWrapper.classList.add('active');
    searchOverlay.classList.add('active');
  }

  function closeSearch() {
    searchWrapper.classList.remove('active');
    searchOverlay.classList.remove('active');
  }

  searchButtons.forEach(button => {
    button.addEventListener('click', openSearch);
  });

  closeButton.addEventListener('click', closeSearch);
  searchOverlay.addEventListener('click', closeSearch);
});

document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.querySelector("#search-input-desktop");
  const form = searchInput.closest("form");
  const emptyState = document.querySelector(".custom-header__empty-state");

  let allowSubmit = false;
  let timeout;

  emptyState.style.display = "none";

  searchInput.addEventListener("input", function () {
    const query = searchInput.value.trim();

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (query.length < 1) {
        allowSubmit = false;
        emptyState.innerHTML = "";
        emptyState.style.display = "none";
        return;
      }

      fetch(
        `/search/suggest.json?q=${encodeURIComponent(
          query
        )}&resources[type]=product`
      )
        .then((res) => res.json())
        .then((data) => {
          const results = data.resources.results.products;
          if (results.length === 0) {
            allowSubmit = false;
            emptyState.innerHTML = `<p>We’re sorry, no results found for "${query}"</p>`;
            emptyState.style.display = "block";
          } else {
            allowSubmit = true;
            emptyState.innerHTML = "";
            emptyState.style.display = "none";
          }
        });
    }, 10);
  });

  form.addEventListener("submit", function (e) {
    if (!allowSubmit) {
      e.preventDefault();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.querySelector("#search-input-desktop");
  const form = searchInput.closest("form");
  const emptyState = document.querySelector(".custom-header__empty-state");

  let allowSubmit = false;
  let timeout;

  searchInput.addEventListener("input", function () {
    const query = searchInput.value.trim();

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (query.length < 1) {
        allowSubmit = false;
        emptyState.innerHTML = "";
        return;
      }

      fetch(
        `/search/suggest.json?q=${encodeURIComponent(
          query
        )}&resources[type]=product`
      )
        .then((res) => res.json())
        .then((data) => {
          const results = data.resources.results.products;
          if (results.length === 0) {
            allowSubmit = false;
            emptyState.innerHTML = `<p>We’re sorry, no results found for "${query}"</p>`;
          } else {
            allowSubmit = true;
            emptyState.innerHTML = "";
          }
        });
    }, 10);
  });

  form.addEventListener("submit", function (e) {
    if (!allowSubmit) {
      e.preventDefault();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".custom-header__search-swiper", {
    slidesPerView: 3.3,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 4,
      },
    },
  });
});
